import * as React from 'react';

import AccordionSection from './component/AccordionSection';

import './Accordion.scss';
import i18n from 'src/translation/i18n';

interface IAccordionProps {
  children: any;
  allowMultipleOpen: boolean;
  startExpanded: boolean;
  showHandleCollapse: boolean;
  header?: any;
  expandAllChild: (option: boolean) => void;
}

interface IAccordionState {
  openedSections: object;
}

class Accordion extends React.Component<IAccordionProps, IAccordionState> {
  constructor(props: any) {
    super(props);

    this.state = {
      openedSections: {}
    };
  }

  public componentDidMount() {
    if (this.props.startExpanded) {
      this.handleExpandAll();
    }
  }

  public componentDidUpdate(prevProps: IAccordionProps) {
    if (
      this.props.startExpanded !== prevProps.startExpanded ||
      this.props.children !== prevProps.children
    ) {
      if (this.props.startExpanded) {
        this.handleExpandAll();
      }
    }
  }

  private handleOpenSection = (identifier: string) => {
    const isOpen = !!this.state.openedSections[identifier];

    if (this.props.allowMultipleOpen) {
      this.setState(prevState => ({
        openedSections: {
          ...prevState.openedSections,
          [identifier]: !isOpen
        }
      }));
    } else {
      this.setState({ openedSections: { [identifier]: !isOpen } });
    }
  };

  private handleCollapseAll = () => {
    const closeSections = {};
    this.props.children.forEach((child: any) => {
      closeSections[child.props.identifier] = false;
    });
    this.setState({ openedSections: { ...closeSections } });
    if (this.props.startExpanded) {
      this.props.expandAllChild(false);
    }
  };

  private handleExpandAll = () => {
    const openSections = {};
    this.props.children.forEach((child: any) => {
      openSections[child.props.identifier] = true;
    });
    this.setState({ openedSections: { ...openSections } });
    if (!this.props.startExpanded) {
      this.props.expandAllChild(true);
    }
  };

  public render() {
    return (
      <table className="rp-accordion">
        <tbody>
          <tr className="rp-accordion--header">
            <td colSpan={7}>
              {this.props.showHandleCollapse && (
                <div className="rp-accordion--header-expand-collapse">
                  <div
                    onClick={this.handleCollapseAll}
                    className="rp-accordion--header-collapse"
                  >
                    <span className="rpds-expand-less" />
                    {i18n.t('myOrders.collapseAll')}
                  </div>
                  <div
                    onClick={this.handleExpandAll}
                    className="rp-accordion--header-expand"
                  >
                    <span className="rpds-expand-more" />
                    {i18n.t('myOrders.expandAll')}
                  </div>
                </div>
              )}
            </td>
          </tr>
          {this.props.header}
          {this.props.children.map((child: any) => (
            <tr key={child.props.identifier}>
              <td className="rp-accordion-section" colSpan={7}>
                <AccordionSection
                  key={child.props.identifier}
                  isOpen={this.state.openedSections[child.props.identifier]}
                  identifier={child.props.identifier}
                  header={child.props.header}
                  onClick={this.handleOpenSection}
                >
                  {child.props.children}
                </AccordionSection>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

export default Accordion;
